module.exports = __webpack_public_path__ + "static/media/socials_photos_052123.d8c774a0.png";